import React from 'react';
import cx from 'classnames';

export default function DefaultAvatar(props: {
  liked?: boolean;
  onClick?: () => void;
  className?: string;
  fill?: string;
}) {
  return (
    <>
      {props.liked ? (
        <svg
          onClick={props.onClick}
          className={cx(
            props.className,
            'icon icon-like',
            props.liked ? 'is-liked' : ''
          )}
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            className="mid"
            d="M6.5 5.5H9L11 6.5L12.5 7L14.5 5L16.5 4.5L18.5 5.5L19 9.5L16 13.5L12 18.5L10 16.5L8 14.5L5.5 11.5L5 7L6.5 5.5Z"
            fill={props.fill || 'white'}
          />
          <path
            className="border"
            d="M18.7939 5.39606C17.1858 3.53465 14.5787 3.53465 12.9708 5.39606L12 6.5195L11.0294 5.39626C9.42129 3.53485 6.81408 3.53485 5.20611 5.39626C3.59796 7.25767 3.59796 10.2753 5.20611 12.1367L6.17669 13.2596L12 20L17.8233 13.2596L18.7937 12.1367C20.4021 10.2753 20.4021 7.25747 18.7939 5.39606ZM15.8822 13.2599L12 17.7535L8.11803 13.2599L6.17703 11.0133C5.10488 9.77246 5.10488 7.76051 6.17703 6.5193C7.24919 5.27849 8.98721 5.27849 10.0592 6.5193L12 8.76638L13.9412 6.5195C15.0132 5.27869 16.7514 5.27869 17.8233 6.5195C18.8953 7.76071 18.8953 9.77226 17.8233 11.0135L15.8822 13.2599Z"
            fill={props.fill || 'white'}
          />
        </svg>
      ) : (
        <svg
          onClick={props.onClick}
          className={cx(
            props.className,
            'icon icon-like',
            props.liked ? 'is-liked' : ''
          )}
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="31"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            className="mid"
            d="M6.5 5.5H9L11 6.5L12.5 7L14.5 5L16.5 4.5L18.5 5.5L19 9.5L16 13.5L12 18.5L10 16.5L8 14.5L5.5 11.5L5 7L6.5 5.5Z"
            fill="none"
          />
          <path
            className="border"
            d="M18.7939 5.39606C17.1858 3.53465 14.5787 3.53465 12.9708 5.39606L12 6.5195L11.0294 5.39626C9.42129 3.53485 6.81408 3.53485 5.20611 5.39626C3.59796 7.25767 3.59796 10.2753 5.20611 12.1367L6.17669 13.2596L12 20L17.8233 13.2596L18.7937 12.1367C20.4021 10.2753 20.4021 7.25747 18.7939 5.39606ZM15.8822 13.2599L12 17.7535L8.11803 13.2599L6.17703 11.0133C5.10488 9.77246 5.10488 7.76051 6.17703 6.5193C7.24919 5.27849 8.98721 5.27849 10.0592 6.5193L12 8.76638L13.9412 6.5195C15.0132 5.27869 16.7514 5.27869 17.8233 6.5195C18.8953 7.76071 18.8953 9.77226 17.8233 11.0135L15.8822 13.2599Z"
            fill="#FFFFFF"
          />
        </svg>
      )}
    </>
  );
}
